import { useContext, useState } from "react";
import styles from "../../assets/sass/viewer3d.module.sass";
import CurrentContext from "../../utils/CurrentContext";

export default function OpenCloseToggle() {
  const {setDoorOpen} = useContext(CurrentContext);
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    setDoorOpen(checked);
  };

  return (
    <>
      <div className={styles.toggleAction}>
        <label className={styles.switch}>
          <input type="checkbox" checked={isChecked} onChange={handleToggle} />
          <span className={`${styles.slider} ${styles.round}`}>
            <span className={styles.toggleText}></span>
          </span>
        </label>
      </div>
    </>
  );
}
